import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './i18n';
import './local';

import './index.scss';
import './portal.css';

const win: any = window;
const lang = win['lang'] === undefined ? document.documentElement.lang : win['lang'];
const rtl = lang === 'ar';
document.documentElement.setAttribute('lang', lang);

ReactDOM.render(
  <React.StrictMode>
    <App rtl={rtl} />
  </React.StrictMode>,
  document.getElementById('root')
);

